module.exports = "img/voice.8c18474.png";